const priceFormatter = function priceFormatterHelper(stringWithDecimal) {
  const shortDecimals = new RegExp(/\.\d$/);
  const noPennies = shortDecimals.test(stringWithDecimal);

  return noPennies ? stringWithDecimal.concat('0') : stringWithDecimal;
};

export default priceFormatter;
